import {BeforeAfterEnum, PanelFragmentDoc} from '../../generated/graphql'
import {getGraphQlFragmentVariables} from '../../client'

import type {BlockMetaInputWithoutDocumentId} from '../../types'
import type {PanelFragment, XcNwBlockFragment} from '../../generated/graphql'
import type {ApolloClient} from '@apollo/client'

export const getPanel = (panelId: string, client: ApolloClient<any>): PanelFragment => {
  const fragmentId = `PanelType:${panelId}`
  const panel = client.readFragment<PanelFragment>({
    id:fragmentId,
    fragment: PanelFragmentDoc,
    fragmentName: 'Panel',
    variables: getGraphQlFragmentVariables(),
  })
  if (!panel) throw new Error(`Programming error - trying to access a not existing cache object: ${fragmentId}`)
  return panel
}

export const updatePanel = (panelId: string, panelData: PanelFragment, client: ApolloClient<any>) => {
  client.writeFragment<PanelFragment>({
    id: `PanelType:${panelId}`,
    fragment: PanelFragmentDoc,
    fragmentName: 'Panel',
    data: panelData,
    variables: getGraphQlFragmentVariables(),
  })
}

export const createOrUpdateHelper = (
  meta: BlockMetaInputWithoutDocumentId,
  newBlock: XcNwBlockFragment,
  client: ApolloClient<any>,
) => {
  const panel = getPanel(meta.panelId, client)
  if (meta.needleBlockId){
    const blocks = panel.blocks.reduce<PanelFragment['blocks']>((prev, curr) => {
      if (curr.id === meta.needleBlockId && meta.position === BeforeAfterEnum.Before){
        return [...prev, newBlock, curr]
      } else if (curr.id === meta.needleBlockId && meta.position === BeforeAfterEnum.After){
        return [...prev, curr, newBlock]
      } else {
        return [...prev, curr]
      }
    }, [])
    updatePanel(panel.id, {...panel, blocks}, client)
  } else if (meta.position === BeforeAfterEnum.Before){
    updatePanel(panel.id, {...panel, blocks: [newBlock, ...panel.blocks]}, client)
  } else if (meta.position === BeforeAfterEnum.After){
    updatePanel(panel.id, {...panel, blocks: [...panel.blocks, newBlock]}, client)
  }
}
